<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        รายงานรายละเอียดภาษีขาย
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">RPFI09</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Sales Tax Detail — รายการใบเสร็จจัดกลุ่มตามจุดรับชำระเงิน
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="groups.length === 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!hasSearched() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'ดูแบบ PDF' }}
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4 no-print">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">receipt_long</span>
          เงื่อนไขรายงาน
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน
      </div>

      <div class="flex flex-col lg:flex-row lg:items-end gap-3 max-w-3xl">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #startDatePicker type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
                [max]="endDate || undefined" (click)="startDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ถึงวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #endDatePicker type="date" [(ngModel)]="endDate" (ngModelChange)="onFilterChange()"
                [min]="startDate || undefined" [max]="maxEndDate" (click)="endDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
        </div>
        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 shrink-0 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">search</span>
          {{ isLoading() ? 'กำลังค้นหา...' : 'ค้นหา' }}
        </button>
      </div>
      <p class="text-[11px] text-slate-400 font-medium">ช่วงวันที่เรียกดูได้สูงสุด 2 เดือน · เฉพาะรายการที่มีเลขที่ใบเสร็จ</p>
    </div>

    <div class="overflow-x-auto min-h-[280px] relative custom-scrollbar p-4 md:p-6 space-y-6">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

      <div *ngIf="!isLoading() && !hasSearched()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search</span>
        <p class="font-bold">เลือกช่วงวันที่ แล้วกดค้นหา</p>
      </div>

      <div *ngIf="hasSearched() && !isLoading() && groups.length === 0" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search_off</span>
        <p class="font-bold">ไม่พบรายการใบเสร็จในช่วงวันที่เลือก</p>
      </div>

      <ng-container *ngFor="let g of groups">
        <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden" [class.opacity-50]="isLoading()">
          <div class="px-4 py-2.5 bg-slate-50 dark:bg-slate-900/60 border-b border-slate-100 dark:border-slate-700 font-bold text-slate-700 dark:text-slate-200">
            จุดรับชำระเงิน: {{ g.posName }}
            <span class="ml-2 text-xs font-semibold text-slate-400">({{ g.rows.length | number }} รายการ)</span>
          </div>
          <table class="w-full text-left border-collapse min-w-[1100px] text-xs">
            <thead class="bg-white/95 dark:bg-slate-800/95">
              <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider text-center whitespace-nowrap">
                <th class="p-2 border border-slate-100 dark:border-slate-700">ลำดับ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">จุดรับชำระเงิน</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">วันเวลา</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">แคชเชียร์</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">เลขที่ใบเสร็จ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700">สถานะ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ค่าบริการ</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ภาษีมูลค่าเพิ่ม</th>
                <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">รวมทั้งสิ้น</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of g.rows" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 tabular-nums">
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ r.seq }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center font-semibold">{{ g.posName }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 whitespace-nowrap">{{ formatDateTime(r.paidDate) }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700">{{ r.cashierName }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 font-mono">{{ r.receiptId }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">
                  <span class="inline-flex px-2 py-0.5 rounded-full text-[11px] font-bold bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">
                    {{ r.statusLabel }}
                  </span>
                </td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.fee | number:'1.2-2' }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.vat | number:'1.2-2' }}</td>
                <td class="p-2 border border-slate-50 dark:border-slate-700 text-right font-bold">{{ r.total | number:'1.2-2' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-slate-50 dark:bg-slate-900/50 font-bold tabular-nums">
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right" colspan="6">รวม {{ g.posName }}</td>
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ g.sumFee | number:'1.2-2' }}</td>
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ g.sumVat | number:'1.2-2' }}</td>
                <td class="p-2 border border-slate-100 dark:border-slate-700 text-right text-amber-700 dark:text-amber-300">{{ g.sumTotal | number:'1.2-2' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </ng-container>

      <div *ngIf="totals && groups.length > 0"
        class="rounded-2xl border-2 border-amber-200 dark:border-amber-800 bg-amber-50/50 dark:bg-amber-950/20 px-5 py-4 flex flex-wrap items-center justify-between gap-3 font-bold">
        <span class="text-slate-700 dark:text-slate-200">
          ยอดรวมทั้งสิ้น
          <span class="text-xs font-semibold text-slate-400 ml-1">({{ totals.rowCount | number }} รายการ)</span>
        </span>
        <div class="flex flex-wrap gap-6 tabular-nums text-sm">
          <span>ค่าบริการ: <span class="text-sky-700 dark:text-sky-300">{{ totals.sumFee | number:'1.2-2' }}</span></span>
          <span>VAT: <span class="text-violet-700 dark:text-violet-300">{{ totals.sumVat | number:'1.2-2' }}</span></span>
          <span>รวม: <span class="text-amber-700 dark:text-amber-300 text-lg">{{ totals.sumTotal | number:'1.2-2' }}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'RPFI09 — รายงานรายละเอียดภาษีขาย (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isProcessingPdf()" text="กำลังโหลดไฟล์ PDF" detail="โปรดรอสักครู่ . . ."></app-pss-loading>
